app.controller('logout', function (authService, $location, messageBanner) {
  authService.reset()
  $location.path('/')
  messageBanner.display('info', 'You have been successfully logged out!', 3000)
})
